export default "__VITE_ASSET__DxDZT3$9__"